@if (value() || extraInfo() || icon()) {
  <div class="details-top-bar-item">
    @if (header() || icon()) {
      <div
        class="details-top-bar-item__header-row"
        matBadgeSize="small"
        matBadgeColor="accent"
        [matBadge]="badge() ?? null"
      >
        @if (icon()) {
          <mat-icon class="details-top-bar-item__icon" color="accent">{{ icon() }}</mat-icon>
        }
        @if (header()) {
          <h3 class="details-top-bar-item__header">{{ header() }}</h3>
        }
      </div>
    }
    @if (value()) {
      <div class="details-top-bar-item__value" [ngClass]="{ 'text-bold': isBold() }">
        {{ value() }}
      </div>
    }
    @if (extraInfo()) {
      <div class="details-top-bar-item__extra-info">
        {{ extraInfo() }}
      </div>
    }
  </div>
}
